import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 70.866 70.866",
  "aria-hidden": "true",
  focusable: "false"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M27.43 39.276H3.735c-2.18 0-3.95 1.768-3.95 3.95v23.692c0 2.18 1.77 3.95 3.95 3.95H27.43c2.18 0 3.948-1.77 3.948-3.95V43.224c0-2.18-1.768-3.948-3.95-3.948zm39.487 0H43.224c-2.18 0-3.95 1.768-3.95 3.95v23.692c0 2.18 1.77 3.95 3.95 3.95h23.693c2.18 0 3.95-1.77 3.95-3.95V43.224c0-2.18-1.77-3.948-3.95-3.948zm0-39.49H43.224c-2.18 0-3.95 1.77-3.95 3.95V27.43c0 2.18 1.77 3.948 3.95 3.948h23.693c2.18 0 3.95-1.768 3.95-3.95V3.737c0-2.18-1.77-3.95-3.95-3.95zm-39.488 0H3.735c-2.18 0-3.95 1.77-3.95 3.95V27.43c0 2.18 1.77 3.948 3.95 3.948H27.43c2.18 0 3.948-1.768 3.948-3.95V3.737c0-2.18-1.768-3.95-3.95-3.95z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }